module.exports = __webpack_public_path__ + "static/media/WP-Snippet-02-small.e364c54d.mp4";